<template>
  <ul class="top-icons d-flex">
    <li :style="{ visibility: isLoggedIn ? 'visible' : 'hidden' }">
      <RouterLink :to="{ name: 'quote-request' }" class="my-requests">
        {{ $t("my_requests") }}
        <span class="position-absolute translate-middle badge rounded-pill bg-danger">
          {{ getTotalProducts }}
        </span>
      </RouterLink>
    </li>

    <template v-for="icon of icons">
      <li
        :key="icon.iconNumber"
        v-if="icon.isEnabled"
        :style="{ visibility: icon.show ? 'visible' : 'hidden' }"
      >
        <BLink
          :to="icon.link"
          v-b-toggle="`topIconsCollapse${showType}${icon.iconNumber}`"
          class="position-relative"
          :class="icon.textClass"
        >
          <img :src="icon.iconPath" />
          <span
            v-if="'badgeValue' in icon"
            class="position-absolute translate-middle badge rounded-pill bg-danger"
          >
            {{ icon.badgeValue }}
          </span>
        </BLink>
      </li>
    </template>
    <BDropdown variant="link">
      <template #button-content>
        <img
          :src="currentLanguageName?.icon"
          :alt="currentLanguageName?.name"
          class="select-country-icon"
        />
        <span class="select-country-name"> {{ currentLanguageName?.name }} </span>
      </template>

      <BDropdownItem
        v-for="language in languages"
        v-bind:key="language"
        @click="changeLanguage(language.value.toLowerCase())"
        class="dropdown-li"
      >
        <img :src="language.icon" class="country-icon" />
        <span class="country-name">{{ language.name }}</span>
      </BDropdownItem>
    </BDropdown>
  </ul>
</template>

<script setup>
import { computed, ref } from "vue";
import DeCountryIcon from "@/esf_venlo_base/assets/svg/de.svg";
import EnCountryIcon from "@/esf_venlo_base/assets/svg/en.svg";
import Profile from "@/esf_venlo_base/assets/svg/profile.svg";
import FillBookmark from "@/esf_venlo_base/assets/svg/fill-bookmark.svg";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { setI18nLanguage, getCurrentLanguage } from "@storefront/core/i18n";
import config from "@config";
import { useCartInfo } from "@storefront/core/composable/cart";

defineProps({
  showType: String,
});

const store = useStore();
const { wishlistCount } = useCartInfo();
const router = useRouter();
const isLoggedIn = computed(() => store.getters["user/getIsLoggedIn"]);
const getTotalProducts = computed(() => store.getters["quote/getTotalProducts"]);
const languages = computed(() => [
  {
    name: "DE",
    value: "de",
    icon: DeCountryIcon,
  },
  {
    name: "EN",
    value: "en",
    icon: EnCountryIcon,
  },
]);

const currentLanguage = ref(getCurrentLanguage());
const currentLanguageName = computed(
  () =>
    languages.value.filter((language) => language.value.toLowerCase() == currentLanguage.value)[0]
);

const icons = computed(() => [
  {
    iconNumber: 3,
    isLinearIcon: true,
    hasBadge: false,
    badgeValue: wishlistCount.value || 0,
    badgeColor: "danger",
    textClass: "wishlist",
    iconPath: FillBookmark,
    // text: "Wensenlijst",
    hasDropdown: true,
    link: "/my-bookmarks",
    menuId: "bookmark",
    isEnabled: true,
    show: isLoggedIn.value,
  },
  {
    iconNumber: 1,
    isLinearIcon: true,
    hasBadge: false,
    iconPath: Profile,
    textClass: "account",
    menuId: "account",
    link: "/account",
    hasDropdown: true,
    isEnabled: isLoggedIn.value,
    show: true,
  },
  {
    iconNumber: 2,
    isLinearIcon: true,
    hasBadge: false,
    iconPath: Profile,
    // text: t("login"),
    textClass: "login",
    hasDropdown: false,
    link: "/login",
    isEnabled: !isLoggedIn.value,
    show: true,
  },
]);

const changeLanguage = (language) => {
  currentLanguage.value = language;
  localStorage.setItem("lang", language);
  setI18nLanguage(language);

  const currentRoute = router.currentRoute.value;
  const currentPath = currentRoute.path;
  const currentQuery = currentRoute.query;

  let newPath = currentPath;
  const pathParts = currentPath.split("/");
  if (
    pathParts.length > 1 &&
    languages.value.some((lang) => lang.value.toLowerCase() === pathParts[1])
  ) {
    newPath = "/" + pathParts.slice(2).join("/");
    if (newPath === "/") newPath = "";
  }

  if (language !== config.languages.default) {
    newPath = "/" + language + newPath;
  }

  if (
    router.currentRoute.value.name !== undefined &&
    router.currentRoute.value.name.includes("category")
  ) {
  } else if (router.currentRoute.value.name == "create-account") {
    router.replace({ path: newPath || "/", query: currentQuery });
    window.location.reload();
  } else {
    router.replace({ path: newPath || "/", query: currentQuery });
  }
};
</script>
